import { render, staticRenderFns } from "./EstatusDocumentos.vue?vue&type=template&id=09c58456"
import script from "./EstatusDocumentos.vue?vue&type=script&lang=js"
export * from "./EstatusDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c58456')) {
      api.createRecord('09c58456', component.options)
    } else {
      api.reload('09c58456', component.options)
    }
    module.hot.accept("./EstatusDocumentos.vue?vue&type=template&id=09c58456", function () {
      api.rerender('09c58456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/EstatusDocumentos.vue"
export default component.exports